export default function MySQL_EXTRACT() {
  return (
    <div>
      <h2>MySQL_EXTRACT</h2>    </div>
  );
}